import { Divider, Skeleton } from '@mui/material';

export function DescriptionContainerSkeleton() {
  return (
    <div className="grid grid-cols-3 gap-4">
      <Secttion />
      <div className="flex gap-3">
        <Divider variant="fullWidth" orientation="vertical" />
        <Secttion />
      </div>
      <div className="flex gap-3">
        <Divider variant="fullWidth" orientation="vertical" />
        <Secttion />
      </div>
    </div>
  );
}

////
function Secttion() {
  return (
    <div className="flex flex-col">
      <Skeleton width={48} height={18} />
      <Skeleton width={96} height={24} />
    </div>
  );
}
